import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const container = document.getElementById('root');
ReactDOM.createRoot(container).render(
  <React.Fragment key="root">
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.Fragment>
);
